import originJSONP from 'jsonp'
import { resolve } from 'path'

/**
 * 封装jsonp
 * @param {*} url 原始的jsonp第一个参数是url，第二个参数是option，这里为了比较好写参数做了下封装
 * @param {obj} data 参数
 * @param {*} option jsonp的option
 */

export default function jsonp(url, data, option) {

    

    url = url  + 'itemid=' + encodeURIComponent(data.itemid) +'&' +'shopid=' + encodeURIComponent(data.shopid)
    console.log('sfjdk',url)
    
    originJSONP('api/getData', option , (err,data) => {
        console.log(data,err)
     
    })
    // return new Promise ((resolve,reject)  => {
    //     originJSONP(url, option , (err,data) => {
    //         console.log(data,err)
    //         if(!err) {
                
    //             resolve(data)
    //         }else{
                
    //             reject(err)
    //         }
    //     })
    // })


}


export function param (data) {
	let url =   'itemid=' + encodeURIComponent(data.itemid) +'&' +'shopid=' + encodeURIComponent(data.shopid)
	
	return url 
  }

